module.exports = __webpack_public_path__ + "img/3.f3a27cf2.png";